import useCommandFlowStore from "../../store/commandFlowStore";

/**
 * Handles the submission of a command in the terminal
 */
export const handleCommandSubmit = (
  e,
  {
    handleUserInput,
    onCommandComplete,
    onStepStart,
    onCommandAbort,
    onCommandBack,
    onCommandStart,
  }
) => {
  e.preventDefault();

  const {
    input,
    setInput,
    history,
    setHistory,
    setHistoryIndex,
    setSuggestionText,
  } = useCommandFlowStore.getState();

  if (input.trim()) {
    // Process the command
    handleUserInput(
      input.trim(),
      onCommandComplete,
      onStepStart,
      undefined, // onStepComplete (not yet wired through here)
      onCommandAbort,
      onCommandBack,
      onCommandStart
    );

    // Reset input state
    setInput("");
    setHistoryIndex(null);
    setSuggestionText("");

    // Add to history if not a duplicate of the last entry
    if (history.length === 0 || history[0] !== input.trim()) {
      const newHistory = [input.trim(), ...history].slice(0, 50);
      setHistory(newHistory);
    }
  }
};
